import { useRef } from 'react'
import { useResizeObserver } from 'usehooks-ts'

import { defaultCamera } from '@frame-builder/lib/frame-viewer/camera'
import { type GalleryCarouselItem } from '@lib/gallery'

import Photo from '@components/photo'
import FrameViewer from '@frame-builder/components/frame-viewer'

interface GalleryCarouselSlideProps {
  index: number
  item: GalleryCarouselItem
  itemAspectRatio?: number
  preloadFirstImage?: boolean
}

const GalleryCarouselSlide = ({
  index,
  item,
  itemAspectRatio,
  preloadFirstImage,
}: GalleryCarouselSlideProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const wrapperRectangle = useResizeObserver({
    ref: wrapperRef,
  })

  const aspectRatio = itemAspectRatio ?? 1
  const width = wrapperRectangle.width
  const height = wrapperRectangle.width
    ? wrapperRectangle.width / aspectRatio
    : undefined

  switch (item.type) {
    case 'image': {
      return (
        <div className="carousel-slide relative flex flex-grow-0 flex-shrink-0 w-full min-h-full overflow-hidden justify-center">
          <Photo
            image={item.image}
            priority={preloadFirstImage && index === 0}
            enableMagnify
          />
        </div>
      )
    }

    case '3d-preview': {
      return (
        <div ref={wrapperRef} className="carousel-slide">
          {!!wrapperRectangle.width && (
            <FrameViewer
              frameSettings={item.frameSettings}
              camera={defaultCamera}
              width={width}
              height={height}
              style={{
                backgroundColor: item.frameSettings.backgroundColor,
              }}
            />
          )}
        </div>
      )
    }
  }

  return null
}

export default GalleryCarouselSlide
